import { render, staticRenderFns } from "./AnnouncementArchivedModal.vue?vue&type=template&id=69b19d6b"
import script from "./AnnouncementArchivedModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementArchivedModal.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementArchivedModal.vue?vue&type=style&index=0&id=69b19d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports